/* Karpet24 withdrawal form (sections/k24-withdrawal-form.liquid).
   Before the post: inline, accessible validation, a time stamp in the mail and a copy
   of what was sent in sessionStorage. After the post: that copy on screen. */
(function () {
  var KEY = 'k24-withdrawal';
  var LOCALES = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-GB' };

  function save(data) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
      /* storage blocked: the page falls back to the generic confirmation */
    }
  }

  function load() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  // Shop time, so the screen, the shop's mail and the receipt we send by hand agree.
  function formatTime(iso, lang) {
    var date = new Date(iso);
    try {
      return new Intl.DateTimeFormat(LOCALES[lang] || lang, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Amsterdam',
        timeZoneName: 'short',
      }).format(date);
    } catch (e) {
      return date.toString();
    }
  }

  function errorFor(field) {
    var ids = (field.getAttribute('aria-describedby') || '').split(' ');
    return document.getElementById(ids[ids.length - 1]);
  }

  function check(field) {
    var value = field.value.trim();
    var message = '';
    if (field.required && !value) message = field.dataset.errorMissing;
    else if (field.type === 'email' && value && field.validity.typeMismatch) message = field.dataset.errorInvalid;
    var error = errorFor(field);
    if (error) {
      error.textContent = message;
      error.hidden = !message;
    }
    if (message) field.setAttribute('aria-invalid', 'true');
    else field.removeAttribute('aria-invalid');
    return !message;
  }

  function showDone(done, lang) {
    var heading = done.querySelector('[data-k24-done-heading]');
    var data = load();
    if (data && data.order) {
      done.querySelectorAll('[data-k24-out]').forEach(function (out) {
        var key = out.dataset.k24Out;
        var value = key === 'at' ? formatTime(data.at, lang) : data[key] || '';
        out.textContent = value || out.dataset.k24Empty || '';
      });
      var reasonRow = done.querySelector('[data-k24-row="reason"]');
      if (reasonRow && !data.reason) reasonRow.hidden = true;
      done.querySelector('[data-k24-done-generic]').hidden = true;
      done.querySelector('[data-k24-done-summary]').hidden = false;
    }
    if (heading) heading.focus({ preventScroll: true });
  }

  function init(root) {
    var lang = root.dataset.locale;
    var done = root.querySelector('[data-k24-withdrawal-done]');
    if (done) return showDone(done, lang);

    var form = root.querySelector('form');
    if (!form) return;
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-k24-field]'));
    var byName = {};
    fields.forEach(function (field) {
      byName[field.dataset.k24Field] = field;
    });

    // Shopify keeps only name and e-mail after a rejected post; put the rest back.
    var draft = load();
    if (form.querySelector('[data-k24-withdrawal-alert]') && draft) {
      ['order', 'items', 'reason'].forEach(function (key) {
        if (byName[key] && !byName[key].value) byName[key].value = draft[key] || '';
      });
    }

    // Our messages replace the browser's bubbles; without JS the native checks still run.
    form.noValidate = true;

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') check(field);
      });
      field.addEventListener('blur', function () {
        if (field.value.trim()) check(field);
      });
    });

    var button = form.querySelector('[data-k24-submit]');
    form.addEventListener('submit', function (event) {
      // One click, one mail: ignore a second submit while the post is under way.
      if (button && button.dataset.busy) return event.preventDefault();
      var firstInvalid = null;
      fields.forEach(function (field) {
        if (field.type !== 'email') field.value = field.value.trim();
        if (!check(field) && !firstInvalid) firstInvalid = field;
      });
      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
        return;
      }

      var at = new Date().toISOString();
      var stamp = form.querySelector('[data-k24-sent-at]');
      if (stamp) stamp.value = formatTime(at, lang) + ' (' + at + ')';
      save({
        name: byName.name.value,
        order: byName.order.value,
        email: byName.email.value.trim(),
        items: byName.items ? byName.items.value : '',
        reason: byName.reason ? byName.reason.value : '',
        at: at,
      });

      if (button) {
        button.dataset.busy = 'true';
        button.setAttribute('aria-disabled', 'true');
        if (button.dataset.labelBusy) button.textContent = button.dataset.labelBusy;
      }
    });
  }

  document.querySelectorAll('[data-k24-withdrawal]').forEach(init);
})();
